<template>
    <b-modal id="modal-esqueci-minha-senha" size="md" title="Redefina sua senha" centered hide-footer @hidden="limparFormulario()">
        <div class="d-flex flex-column" v-if="!foiEnviadoComSucesso">
            <label>Por favor digite seu endereço de email:</label>
            <b-input v-model="email" type="email" placeholder="email@email.com"/>
            <div class="d-flex w-100 justify-content-end mt-2">
                <b-button variant="success" :disabled="carregandoEnviarFormulario" @click="enviarFormulario()">
                    <b-spinner variant="white" v-if="carregandoEnviarFormulario"></b-spinner>
                    <span v-else>
                        Enviar
                    </span>
                </b-button>
            </div>
        </div>
        <div class="d-flex gap-md flex-column" v-else>
            <h5>Enviamos as instruções de redefinição de senha para o email {{ email }}</h5>
            <div>
                <b-button variant="success" @click="$bvModal.hide('modal-esqueci-minha-senha')">
                    OK
                </b-button>
            </div>
        </div>
    </b-modal>
</template>
<script>
import AuthService from "../../service/AuthService.js";

export default{
	name: "ModalEsqueciMinhaSenha",
	data() {
		return {
			foiEnviadoComSucesso: false,
	        email: "",
			carregandoEnviarFormulario: false,
		};
	},
	methods: {
		enviarFormulario() {
			if (!this.email) {
				this.mensagem("Email é um campo obrigatório", "Aviso", "warning");
				return;
			}
			const form = {
				email: this.email,
			};
			this.carregandoEnviarFormulario = true;
			AuthService.enviarFormularioEsqueciMinhaSenha(form)
				.then(() => {
					this.foiEnviadoComSucesso = true;
				})
				.catch((err) => {
					if (err.response) {
						this.mensagem(err.response.data, "Erro", "danger");
					} else {
						this.mensagem("Não foi possível concluir essa ação nesse momento, por favor tente novamento mais tarde", "Erro", "danger");
					}
				}).finally(() => {
					this.carregandoEnviarFormulario = false;
				});
		},
		limparFormulario() {
			this.email = "";
			this.foiEnviadoComSucesso = false;
		},
		mensagem(msg, titulo, variant) {
			this.$bvToast.toast(msg, {
				title: titulo,
				autoHideDelay: 6000,
				appendToast: true,
				variant,
				toaster: "b-toaster-bottom-right",
			});
		},
	} };

</script>



// WEBPACK FOOTER //
// src/components/Login/ModalEsqueciMinhaSenha.vue